// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + ({"337":"NotFound-vue","375":"Setting-vue","638":"GeoBlocker-vue","725":"GeoRedirectAdd-vue","818":"GeoRedirect-vue","927":"Dashboard-vue"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};